﻿/** One photo is all onboarding demands (11 Sep). The blocker was the MINIMUM of four, not the maximum: nobody was ever forced to upload six. Raise PHOTO_MIN again only if profile quality drops. UN8 still keeps ID + confirmation video. */
export const PHOTO_MIN = 1;
export const PHOTO_MAX = 6;

/** Soft client limits — tighten server-side later. */
export const ID_MAX_BYTES = 12 * 1024 * 1024; // 12 MB
export const VIDEO_MAX_BYTES = 50 * 1024 * 1024; // 50 MB
export const PHOTO_MAX_BYTES = 12 * 1024 * 1024; // 12 MB
/** Auto-stop confirmation recording (seconds). Short clip is enough. */
export const VIDEO_MAX_SECONDS = 15;

export const ID_ACCEPT = "image/*,.pdf,application/pdf";
export const VIDEO_ACCEPT = "video/*";
export const PHOTO_ACCEPT = "image/*";

export const ID_MIME_OK = /^(image\/|application\/pdf)/;
export const VIDEO_MIME_OK = /^video\//;
export const PHOTO_MIME_OK = /^image\//;
